export interface Lazy<T> {
  (): T;
  then<T1>(modifier: (a: T) => Lazy<T1>): Lazy<T1>;
  map<T1>(mapper: (a: T) => T1): Lazy<T1>;
  isLazy: boolean;
}

const lazy = <T>(supplier: () => T): Lazy<T> => {
  let evaluated = false;
  let result: T;
  const val = () => {
    if (evaluated) {
      return result;
    }
    result = supplier();
    evaluated = true;
    return result;
  };
  val.isLazy = true;
  val.then = <T1>(modifier: (a: T) => Lazy<T1>): Lazy<T1> => modifier(val());
  val.map = <T1>(mapper: (a: T) => T1): Lazy<T1> => lazy(() => mapper(val()));
  return val;
};

export default lazy;
